(() => {
  const focusItem = (item) => {
    if (!item) return;
    item.open = true;
    item.querySelector('summary')?.focus({ preventScroll: true });
    item.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  };

  document.querySelectorAll('[data-knowledge-faq]').forEach((root) => {
    try {
      const items = [...root.querySelectorAll('[data-faq-item]')];
      if (!items.length) return;
      const singleOpen = root.dataset.singleOpen === 'true';

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open && singleOpen) items.forEach((other) => { if (other !== item) other.open = false; });
          if (item.open && window.location.hash !== `#${item.id}`) {
            window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}#${item.id}`);
          } else if (!item.open && window.location.hash === `#${item.id}`) {
            window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`);
          }
        });
      });

      const openFromHash = () => {
        const id = window.location.hash.slice(1);
        if (!id) return;
        focusItem(items.find((item) => item.id === id));
      };
      window.addEventListener('hashchange', openFromHash);
      openFromHash();
    } catch (_) {
      const error = root.querySelector('[data-faq-error]');
      if (error) error.hidden = false;
    }
  });
})();